<template>
  <div class="webshop-cart-item flex w-full pl-5" :class="{ 'webshop-cart-item--checkout': isCheckoutType }">
    <div class="photo-container relative">
      <OImage
        v-bind="getImagePaths(`/images/frontend/loyalty/products/${cartItem.slug}/product`)"
        img-class="rounded"
      />
      <div v-if="canEdit" class="quantity-controls">
        <div class="quantity-controls--inner ota-p18">
          <button :aria-label="$t('Accessibilty.AriaLabels.RemoveCartItem', { product: cartItem.name })" class="focus:outline-none" @click="$emit('minus', cartItem)">
            -
          </button>
          <div>{{ cartItem.quantity }}</div>
          <button :aria-label="$t('Accessibilty.AriaLabels.AddCartItem', { product: cartItem.name })" class="focus:outline-none" @click="$emit('plus', cartItem)">
            +
          </button>
        </div>
      </div>
    </div>
    <div class="px-5 flex-1 flex-col flex">
      <div class="max-w-full flex-1">
        <p
          class="ota-p16 mb-5"
          :class="{ 'mb-rem': isCheckoutType }"
          v-text="`${cartItem.name} (${cartItem.quantity})`"
        />
        <p
          class="ota-p16 font-extrabold mb-7"
          :class="{ 'mb-rem': isCheckoutType }"
          v-text="toEuros(cartItem.price)"
        />
        <p class="ota-p16" v-html="`${$t('Loyalty.Webshop.Cart.Size')} <span class='ota-p16 font-semibold'>${cartItem.sizeLabel}</span>`" />
        <p class="ota-p16" v-html="`${$t('Loyalty.Webshop.Cart.Color')} <span class='ota-p16 font-semibold'>${cartItem.color}</span>`" />
      </div>
      <div v-if="canEdit" class="flex justify-end">
        <button
          class="ota-p14 underline cursor-pointer"
          @click="$emit('remove', cartItem)"
        >
          {{ $t('Loyalty.Webshop.Cart.Remove') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import OImage from '@/components/OImage'
import { getImagePaths, getEuros } from '@/utils/general'
import { CartTypes } from '@/enums/webshop'

export default {
  name: 'WebshopCartItem',
  components: { OImage },
  props: {
    cartItem: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: CartTypes.Cart,
      validator: value => Object.keys(CartTypes).includes(value)
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isCheckoutType () {
      return this.type === CartTypes.Checkout
    }
  },
  methods: {
    getImagePaths (path = '') {
      return getImagePaths({ path, extension: '.webp', s3: true })
    },
    toEuros (price = '0') {
      return getEuros(this.country, price, true)
    }
  }
}
</script>

<style lang="postcss" scoped>
.webshop-cart-item {
  .photo-container {
    width: 12.6rem;
    height: 17.9rem;

    .oimage >>> img {
      @apply object-cover min-h-full max-h-full min-w-full;
      max-width: 100% !important;
    }

    .quantity-controls {
      @apply absolute w-full px-rem;
      bottom: 1rem;

      &--inner {
        @apply bg-white flex justify-evenly items-center w-full max-w-full;

        & button {
          @apply flex-1;
          padding: .6rem 0;
        }
      }
    }
  }

  .ota-p14 {
    @apply text-sm !important;
  }
}

.webshop-cart-item--checkout {
  .photo-container {
    width: 10rem;
    height: 11.9rem;

    .quantity-controls {
      @apply px-2;
    }
  }
}
</style>
